export const clsteacherAssignApi = {
    heading:[
        {
            head:"Class"
        },
        {
            head:"Section"
        },
        {
            head:"Subject"
        },
        {
            head:"Subgroup"
        },
        {
            head:"Event"
        },
        {
            head:"Teacher"
        },
        {
            head:"Action"
        }
    ],
    data:[
        {
            id:1,
            class:"Starter", 
            section:"Diamond 1", 
            exam:"2nd Semester Assessment",
            subject:"English",
            subgroup:"subgroup",
            event:"assignment1",
            teacher:"Rafiq Alam",
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {
            id:2,
            class:"Class 3", 
            section:"Diamond 1", 
            exam:"1st Semester Assessment",
            subject:"English",
            subgroup:"subgroup",
            event:"assignment1",
            teacher:"Rafiq Alam",
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {
            id:1,
            class:"Starter", 
            section:"Diamond 1", 
            exam:"2nd Semester Assessment",
            subject:"English",
            subgroup:"subgroup",
            event:"assignment1",
            teacher:"Rafiq Alam",
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {
            id:2,
            class:"Class 3", 
            section:"Diamond 1", 
            exam:"1st Semester Assessment",
            subject:"English",
            subgroup:"subgroup",
            event:"assignment1",
            teacher:"Rafiq Alam",
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {
            id:1,
            class:"Starter", 
            section:"Diamond 1", 
            exam:"2nd Semester Assessment",
            subject:"English",
            subgroup:"subgroup",
            event:"assignment1",
            teacher:"Rafiq Alam",
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {
            id:2,
            class:"Class 3", 
            section:"Diamond 1", 
            exam:"1st Semester Assessment",
            subject:"English",
            subgroup:"subgroup",
            event:"assignment1",
            teacher:"Rafiq Alam",
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {
            id:1,
            class:"Starter", 
            section:"Diamond 1", 
            exam:"2nd Semester Assessment",
            subject:"English",
            subgroup:"subgroup",
            event:"assignment1",
            teacher:"Rafiq Alam",
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {
            id:2,
            class:"Class 3", 
            section:"Diamond 1", 
            exam:"1st Semester Assessment",
            subject:"English",
            subgroup:"subgroup",
            event:"assignment1",
            teacher:"Rafiq Alam",
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {
            id:1,
            class:"Starter", 
            section:"Diamond 1", 
            exam:"2nd Semester Assessment",
            subject:"English",
            subgroup:"subgroup",
            event:"assignment1",
            teacher:"Rafiq Alam",
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {
            id:2,
            class:"Class 3", 
            section:"Diamond 1", 
            exam:"1st Semester Assessment",
            subject:"English",
            subgroup:"subgroup",
            event:"assignment1",
            teacher:"Rafiq Alam",
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {
            id:1,
            class:"Starter", 
            section:"Diamond 1", 
            exam:"2nd Semester Assessment",
            subject:"English",
            subgroup:"subgroup",
            event:"assignment1",
            teacher:"Rafiq Alam",
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {
            id:2,
            class:"Class 3", 
            section:"Diamond 1", 
            exam:"1st Semester Assessment",
            subject:"English",
            subgroup:"subgroup",
            event:"assignment1",
            teacher:"Rafiq Alam",
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {
            id:1,
            class:"Starter", 
            section:"Diamond 1", 
            exam:"2nd Semester Assessment",
            subject:"English",
            subgroup:"subgroup",
            event:"assignment1",
            teacher:"Rafiq Alam",
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {
            id:2,
            class:"Class 3", 
            section:"Diamond 1", 
            exam:"1st Semester Assessment",
            subject:"English",
            subgroup:"subgroup",
            event:"assignment1",
            teacher:"Rafiq Alam",
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {
            id:1,
            class:"Starter", 
            section:"Diamond 1", 
            exam:"2nd Semester Assessment",
            subject:"English",
            subgroup:"subgroup",
            event:"assignment1",
            teacher:"Rafiq Alam",
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {
            id:2,
            class:"Class 3", 
            section:"Diamond 1", 
            exam:"1st Semester Assessment",
            subject:"English",
            subgroup:"subgroup",
            event:"assignment1",
            teacher:"Rafiq Alam",
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {
            id:1,
            class:"Starter", 
            section:"Diamond 1", 
            exam:"2nd Semester Assessment",
            subject:"English",
            subgroup:"subgroup",
            event:"assignment1",
            teacher:"Rafiq Alam",
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {
            id:2,
            class:"Class 3", 
            section:"Diamond 1", 
            exam:"1st Semester Assessment",
            subject:"English",
            subgroup:"subgroup",
            event:"assignment1",
            teacher:"Rafiq Alam",
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
        {
            id:1,
            class:"Starter", 
            section:"Diamond 1", 
            exam:"2nd Semester Assessment",
            subject:"English",
            subgroup:"subgroup",
            event:"assignment1",
            teacher:"Rafiq Alam",
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
        },
       
        
     
       
    ]
}

